import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/**
 * Blocks access to internal cost detail pages (one-time, recurring).
 * Directors with only "aggregate" access (or no grant) are redirected.
 * CEO and accountants always pass through.
 */
export function InternalCostFullGuard() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/auth/login" replace />;
  if (user.is_ceo || user.role === "accountant") return <Outlet />;
  // Non-technical directors always have access (branch-filtered on backend)
  if (user.role === "director" && !user.is_technical_director) return <Outlet />;
  if (user.role === "director" && user.internal_cost_access_level === "full") return <Outlet />;
  return <Navigate to="/finances" replace />;
}
